import { render, staticRenderFns } from "./Lesiones.vue?vue&type=template&id=f7d8edb6"
import script from "./Lesiones.vue?vue&type=script&lang=js"
export * from "./Lesiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports